import { useField } from "formik";
import React, {useState} from "react";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

const SelectBox = ({
  label = "",
  id = "",
  value,
  className = "",
  options,
  handleVal,
  onClick = null,
  name
}) => {
  const [field, meta] = useField(name);
  const [disabled, setDisabled] = useState(false)
  const handleOnChange = (value) => {
    handleVal(value);
  };
  
  return (
    <>
      <FormGroup className={className}>
        {label && <Label htmlFor={id}>{label}</Label>}

        <Input
        style={{paddingRight: "35px"}}
          onClick={onClick}
          type="select"
          name={name}
          id={id}
          value={value != null || value != "" ? value : null}
          onChange={($event) => {
            setDisabled(true)
            handleOnChange($event.target.value);
          }}
          className="form-select"
          // {...field}
        >
          <option disabled={disabled}>Select</option>
          {options &&
            options.map((item, index) => {
              return (
                <option
                  key={index}
                  selected={item.value == value}
                  value={item.value}
                  disabled={item.disabled ? true : false}
                >
                  {item.label}
                </option>
              );
            })}
        </Input>
        {meta.touched && meta.error && (
          <FormFeedback className="d-block">
            {" "}
            {meta?.error}
            {/* <FormattedMessage id={meta.error} values={{
              name: props?.placeholder || 'This'
            }} /> */}
          </FormFeedback>
        )}
        
      </FormGroup>
    </>
  );
};
export default SelectBox;
